import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Stack
} from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import * as productCategoryService from '../services/productCategoryService';

const ProductCategories = () => {
  const [categories, setCategories] = useState([]);
  const [open, setOpen] = useState(false);
  const [editCat, setEditCat] = useState(null);
  const [categoryName, setCategoryName] = useState('');

  const fetchCategories = async () => {
    const data = await productCategoryService.getCategories();
    setCategories(data);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleSave = async () => {
    if (editCat) {
      await productCategoryService.updateCategory(editCat.Id, { CategoryName: categoryName });
    } else {
      await productCategoryService.addCategory({ CategoryName: categoryName });
    }
    await fetchCategories();
    setOpen(false);
    setEditCat(null);
    setCategoryName('');
  };

  const handleDelete = async (id) => {
    await productCategoryService.deleteCategory(id);
    await fetchCategories();
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => {
            setOpen(true);
            setEditCat(null);
            setCategoryName('');
          }}
        >
          Add Category
        </Button>
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Category Name</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(categories?.payload || []).map((cat) => (
            <TableRow key={cat.Id}>
              <TableCell>{cat.CategoryName}</TableCell>
              <TableCell align="right">
                <IconButton
                  onClick={() => {
                    setEditCat(cat);
                    setCategoryName(cat.CategoryName);
                    setOpen(true);
                  }}
                >
                  <Edit />
                </IconButton>
                <IconButton color="error" onClick={() => handleDelete(cat.Id)}>
                  <Delete />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{editCat ? 'Edit Category' : 'Add Category'}</DialogTitle>
        <DialogContent>
          <TextField
            label="Category Name"
            value={categoryName}
            onChange={e => setCategoryName(e.target.value)}
            fullWidth
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProductCategories;